import { useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
export var useAppDispatch = function () { return useDispatch(); };
export var useAppSelector = useSelector;
export var useCheckToken = function () {
    return !!localStorage.getItem('token');
};
export function useDebounce(callback, delay) {
    var timer = useRef(null);
    var debounceCallback = useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (timer.current) {
            clearTimeout(timer.current);
        }
        timer.current = setTimeout(function () {
            callback.apply(void 0, args);
        }, delay);
    }, []);
    return debounceCallback;
}
